// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Components Imports

// Actions Imports

// Services Imports

// Internal Imports
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { COMPONENT_FEATURE } = DOCUMENTS;

export default function ComponentDeleteBtn({
  mode,
  section,
  handleDeleteButton,
}) {
  if (
    (!COMPONENT_FEATURE[mode].deleteSection || section.lock === true) &&
    !section.removable
  ) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      overlay="Delete this block"
      align={{ offset: [0, 3] }}>
      <span
        data-test="documentitems-delete-the-content-btn"
        className="btn-icon"
        id="delete-the-content-btn"
        onMouseDown={handleDeleteButton}
        role="button"
        tabIndex={0}>
        <FontAwesomeIcon icon={["far", "trash-alt"]} />
      </span>
    </Tooltip>
  );
}
